import { createContext, useContext } from 'react';

export interface OnboardingControl {
  /** 온보딩 투어가 진행 중인지(첫 방문 or 어드민 미리보기). true면 하단탭 등 스포일러 UI를 숨긴다. */
  active: boolean;
  /** 어드민 미리보기: 앱 레벨에서 실제 온보딩을 띄운다(둘러보기·탭숨김까지 동일). */
  startPreview: (welcome: string) => void;
}

export const OnboardingActiveContext = createContext<OnboardingControl>({
  active: false,
  startPreview: () => {},
});

export const useOnboardingActive = () => useContext(OnboardingActiveContext).active;
export const useOnboardingControl = () => useContext(OnboardingActiveContext);
